const CountriesLoading = () =>{
  return(
    <>
     <div className="row">
      <div className="col-sm-3 col-md-4 col-xl-3">
         {/* placeholder */}
         <div className="card" aria-hidden="true">
         <img className='card-img-top' src="..." alt="" style={{height:'12rem'}} />
         <div className="card-body">
          <h5 className="card-title placeholder-glow">
            <span className="placeholder col-6"></span>
          </h5>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-6"></span>
            <span className="placeholder col-8"></span>
          </p>
         </div>
         </div>
      </div>
      
      
      <div className="col-sm-3 col-md-4 col-xl-3">
         {/* placeholder */}
         <div className="card" aria-hidden="true">
         <img className='card-img-top' src="..." alt="" style={{height:'12rem'}} />
         <div className="card-body">
          <h5 className="card-title placeholder-glow">
            <span className="placeholder col-6"></span>
          </h5>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-6"></span>
            <span className="placeholder col-8"></span>
          </p>
         </div>
         </div>
      </div>
      

      <div className="col-sm-3 col-md-4 col-xl-3">
         {/* placeholder */}
         <div className="card" aria-hidden="true">
         <img className='card-img-top' src="..." alt="" style={{height:'12rem'}} />
         <div className="card-body">
          <h5 className="card-title placeholder-glow">
            <span className="placeholder col-6"></span>
          </h5>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-6"></span>
            <span className="placeholder col-8"></span>
          </p>
         </div>
         </div>
      </div>
      

      <div className="col-sm-3 col-md-4 col-xl-3">
         {/* placeholder */}
         <div className="card" aria-hidden="true">
         <img className='card-img-top' src="..." alt="" style={{height:'12rem'}} />
         <div className="card-body">
          <h5 className="card-title placeholder-glow">
            <span className="placeholder col-6"></span>
          </h5>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-6"></span>
            <span className="placeholder col-8"></span>
          </p>
         </div>
         </div>
      </div>
      

      <div className="col-sm-3 col-md-4 col-xl-3">
         {/* placeholder */}
         <div className="card" aria-hidden="true">
         <img className='card-img-top' src="..." alt="" style={{height:'12rem'}} />
         <div className="card-body">
          <h5 className="card-title placeholder-glow">
            <span className="placeholder col-6"></span>
          </h5>
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-4"></span>
            <span className="placeholder col-6"></span>
            <span className="placeholder col-8"></span>
          </p>
         </div>
         </div>
      </div>
     </div>
    </>
  )
}
export default CountriesLoading;